import { AxiosInstance } from 'axios';
import { Features } from '../types';

/**
 * Feature flips for the signed-in user.
 *
 * The region resolves `FeatureFlips:*` from its shared settings per user, so
 * these are answers about this person, not static configuration.
 */
export class FeaturesApi {
  constructor(private client: AxiosInstance) {}

  async getFeatures(): Promise<Features> {
    const response = await this.client.get<Features>('/api/features');
    return response.data;
  }
}
